// frontend/src/utils/intents/intentUtils.js
import { API_BASE } from '../../api/config';
import { queryVectorMemory } from '../../api/memory';

console.log('[⚙️ Intent API BASE]', API_BASE);

const recallPatterns = [
  { pattern: /do you (remember|know).*my (mom|mother)/i, intent: 'recall_request', target: 'mother' },
  { pattern: /do you (remember|know).*my (dad|father)/i, intent: 'recall_request', target: 'father' },
  { pattern: /do you (remember|know).*my (brother)/i, intent: 'recall_request', target: 'brother' },
  { pattern: /do you (remember|know).*my (sister)/i, intent: 'recall_request', target: 'sister' },
  { pattern: /do you (remember|know).*my (son)/i, intent: 'recall_request', target: 'son' },
  { pattern: /do you (remember|know).*my (daughter)/i, intent: 'recall_request', target: 'daughter' },
  { pattern: /do you (remember|know).*my (wife)/i, intent: 'recall_request', target: 'wife' },
  { pattern: /do you (remember|know).*my (husband)/i, intent: 'recall_request', target: 'husband' },
  { pattern: /do you (remember|know).*my (friend|buddy|pal)/i, intent: 'recall_request', target: 'friend' },
  { pattern: /do you (remember|know).*my (grandma|grandmother)/i, intent: 'recall_request', target: 'grandmother' },
  { pattern: /do you (remember|know).*my (grandpa|grandfather)/i, intent: 'recall_request', target: 'grandfather' },
  { pattern: /do you (remember|know).*my (aunt|aunts)/i, intent: 'recall_request', target: 'aunt' },
  { pattern: /do you (remember|know).*my (uncle|uncles)/i, intent: 'recall_request', target: 'uncle' },
  { pattern: /do you (remember|know).*my (cousin|cousins)/i, intent: 'recall_request', target: 'cousin' },
  { pattern: /do you (remember|know).*my (girlfriend)/i, intent: 'recall_request', target: 'girlfriend' },
  { pattern: /do you (remember|know).*my (boyfriend)/i, intent: 'recall_request', target: 'boyfriend' },
  { pattern: /do you (remember|know).*my (ex[-\s]?girlfriend)/i, intent: 'recall_request', target: 'ex-girlfriend' },
  { pattern: /do you (remember|know).*my (ex[-\s]?boyfriend)/i, intent: 'recall_request', target: 'ex-boyfriend' },
  { pattern: /do you (remember|know).*my (ex[-\s]?wife)/i, intent: 'recall_request', target: 'ex-wife' },
  { pattern: /do you (remember|know).*my (ex[-\s]?husband)/i, intent: 'recall_request', target: 'ex-husband' },
  { pattern: /(?:show|what(?:'s| is)|display|see|recall).*(?:my |the |our |a )?(?:main )?(grocery|shopping) list/i, intent: 'recall_request', target: 'grocery list'}
  
];
const LIST_PHRASES = [
  "add this to my list",
  "add to grocery list",
  "add to my list",
  "create a grocery list",
  "create a list",
  "here is a list",
  "here’s my list",
  "i need to buy",
  "make a grocery list",
  "make a list",
  "my grocery list is",
  "my todo list is",
  "start a grocery list",
  "start a list",
  "start my grocery list",
  "these are my tasks",
];


const REMINDER_PHRASES = [
  "remind me",
  "don't forget to",
  "note to self",
  "remember to",
  "make a note to",
  "create a reminder",
  "set a reminder"
];

const PRAYER_PHRASES = [
  "pray for me",
  "say a prayer",
  "keep me in your prayers",
  "need a prayer",
  "i’m asking for prayer",
  "please pray",
  "pray with me"
];
const COMFORT_PHRASES = [
  "i’m having a hard time",
  "i feel sad",
  "i'm struggling",
  "i'm hurting",
  "i feel alone",
  "i feel overwhelmed",
  "i feel broken",
  "i feel empty",
  "i need comfort",
  "i need support"
];
const GRATITUDE_MEMORY_PHRASES = [
  "i’m grateful",
  "i am grateful",
  "i’m thankful",
  "i am thankful",
  "i appreciate",
  "i’m so blessed"
];
const AFFIRMATION_PHRASES = [
  "i believe in myself",
  "i’ve got this",
  "i know i can do it",
  "i feel strong today",
  "i’m confident",
  "i trust myself"
];
const HUMOR_PHRASES = [
  "tell me a joke",
  "say something funny",
  "make me laugh"
];
const DREAM_PHRASES = [
  "i had a dream",
  "i dreamt that",
  "my dream was",
  "last night i dreamed",
  "remember this dream"
];
const QUOTE_PHRASES = [
  "here's a quote",
  "here is a quote",
  "i want to remember this quote",
  "save this quote",
  "remember this quote"
];
const LOSS_PHRASES = [
  "i feel so lost",
  "i miss",
  "passed away",
  "she died",
  "he died",
  "grieving",
  "my heart is broken"
];
const NAP_PHRASES = [
  "taking a nap",
  "going to nap",
  "going to take a nap",
  "i need a nap",
  "i'm going to nap",
  "i’m going to nap",
  "i am going to nap",
  "i’m going to take a nap",
  "i am going to take a nap",
  "i need rest",
  "going to lie down",
  "i'm lying down",
  "i’m lying down",
  "i'm going to sleep",
  "i am going to sleep",
  "i'm resting",
  "i am resting",
  "i’m resting"
];



async function detectIntent(message, shadowId = null) {
  const lower = message.toLowerCase().trim(); // 🧠 used in pattern matching
  console.log('🧪 detectIntent running — message:', message, '| lower:', lower);

  let vectorHints = [];
  try {
    if (shadowId) {
      const res = await queryVectorMemory({ text: message, shadowId });
      vectorHints = res?.matches || [];
      console.log('🧠 Vector memory matches:', vectorHints);
    }
  } catch (err) {
    console.error('❌ Vector memory query failed:', err.message);
  }

  if (LIST_PHRASES.some(p => lower.includes(p))) return { intent: 'list_create', target: null, vectorHints };
  if (REMINDER_PHRASES.some(p => lower.includes(p))) return { intent: 'reminder_request', target: null, vectorHints };
  if (PRAYER_PHRASES.some(p => lower.includes(p))) return { intent: 'prayer_request', target: null, vectorHints };
  if (HUMOR_PHRASES.some(p => lower.includes(p))) return { intent: 'humor_request', target: null, vectorHints };
  if (AFFIRMATION_PHRASES.some(p => lower.includes(p))) return { intent: 'affirmation', target: null, vectorHints };
  if (COMFORT_PHRASES.some(p => lower.includes(p))) return { intent: 'comfort', target: null, vectorHints };
  if (LOSS_PHRASES.some(p => lower.includes(p))) return { intent: 'loss', target: null, vectorHints };
  if (QUOTE_PHRASES.some(p => lower.includes(p))) return { intent: 'quote_capture', target: null, vectorHints };
  if (DREAM_PHRASES.some(p => lower.includes(p))) return { intent: 'dream_note', target: null, vectorHints };
  if (GRATITUDE_MEMORY_PHRASES.some(p => lower.includes(p))) return { intent: 'gratitude_memory', target: null, vectorHints };
  if (lower.includes('thank')) return { intent: 'gratitude', target: null, vectorHints };
  if (lower.startsWith('hello') || lower.startsWith('hi') || lower.startsWith('hey')) return { intent: 'greeting', target: null, vectorHints };

const negationTerms = ["don't", "not", "isn't", "wasn't", "never", "no intention", "won’t"];

const isNegated = negationTerms.some(neg => lower.includes(neg));
const isExplicitNap = NAP_PHRASES.some(p => lower.includes(p));

if (isExplicitNap && !isNegated) {
  return { intent: 'nap', target: null, vectorHints };
}


  // 🧠 Recall patterns (skip if trivia-style)
if (!isTriviaQuestion(lower)) {
  for (let rule of recallPatterns) {
    if (rule.pattern.test(lower)) {
      console.log(`📚 Matched recall pattern: ${rule.intent} → ${rule.target}`);
      return { intent: rule.intent, target: rule.target, vectorHints };
    }
  }
}

//  for (let rule of recallPatterns) {
//    if (rule.pattern.test(lower)) {
//      console.log(`📚 Matched recall pattern: ${rule.intent} → ${rule.target}`);
//      return { intent: rule.intent, target: rule.target, vectorHints };
//    }
//  }

// 🔁 Fallback — send to LLM intent router
try {
  // 🔹 AFTER THIS LINE — existing fallback block begins
  console.log("⚠️ Reached fallback — sending to LLM intent router");

  const stored = localStorage.getItem('daisy-user');
  const token = stored ? JSON.parse(stored).token : '';

  // 🔍 NEW: Optional context injection
  const memoryData = localStorage.getItem('daisy-memory');
  let context = {};

  if (memoryData) {
    try {
      const parsedMemory = JSON.parse(memoryData);
      if (Array.isArray(parsedMemory.relationships)) {
        context.relationships = parsedMemory.relationships;
        console.log('📦 Injected context.relationships into fallback:', context.relationships);
      }
    } catch (err) {
      console.warn('❌ Failed to parse memory context:', err.message);
    }
  }

  const response = await fetch(`${API_BASE}/api/intent/fallback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ message, context }),
  });

  console.log('📡 [IntentFallback] Response status:', response.status);
  const result = await response.json();

  // 🛡️ Trivia intent override
  if (
    (result.intent === 'memory_recall' || result.intent === 'recall_request') &&
    isTriviaQuestion(message)
  ) {
    console.warn('[Intent Override] Corrected memory_recall → trivia_question for:', message);
    result.intent = 'trivia_question';
  }

  // 🧠 Soft greeting follow-ups (prevent redundant intent)
  const softGreetingPhrases = [
    'good so far',
    'so far so good',
    'pretty good this morning',
    'doing okay today',
    'not bad so far',
    'been alright this morning',
    'doing well so far',
    'going fine today',
    'today’s been good',
    'morning’s going fine',
    'so far everything’s fine'
  ];

  if (
    result.intent === 'greeting' &&
    softGreetingPhrases.some(p => lower.includes(p)) &&
    (result.emotion === 'neutral' || !result.emotion)
  ) {
    console.warn('[Intent Override] Soft follow-up greeting → smalltalk');
    result.intent = 'smalltalk';
  }

  return { ...result, vectorHints };

  // 🔹 BEFORE THIS LINE — fallback block ends
} catch (err) {
  console.error('❌ [IntentFallback] Error:', err.message);
}


return { intent: 'unknown', target: null, vectorHints };
}

// ✅ Helpers
function isTriviaQuestion(message = '') {
  const lower = message.toLowerCase().trim();
  const starters = [
    'who is', 'what is', 'when was', 'where is',
    'how many', 'how much', 'what year', 'name the',
    'who won', 'define', 'explain', 'list the', 'give me the'
  ];
  return starters.some(phrase => lower.startsWith(phrase));
}

function isTriviaAnswer(message = '') {
  return /^[A-Z][a-z]+(?:\s[A-Z][a-z]+)*$/.test(message);
}

// ✅ Export block
export { detectIntent, isTriviaQuestion, isTriviaAnswer };

